import { render } from "./ModalButtons.vue?vue&type=template&id=20011fcb"
import script from "./ModalButtons.vue?vue&type=script&lang=js"
export * from "./ModalButtons.vue?vue&type=script&lang=js"

import "./ModalButtons.vue?vue&type=style&index=0&id=20011fcb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__